import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

@Injectable()
export class UserService {
  user: Observable<firebase.User>;

  constructor(public afAuth: AngularFireAuth) {
    this.user = afAuth.authState;
  }

  userIsLoggedIn() {
    return new Promise((resolve) => {
      this.afAuth.authState.subscribe(res => {
        if (res && res.uid) {
          resolve(true);
        } else {
          resolve(false)
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/user.service.ts